import type { Maybe } from '@adornis/base/utilTypes.js';
import { UserRole } from '@ils/static/enums.js';

export const UserTypeCheck = (type: string) => {
  if (type in UserRole) return true;
  return false;
};

export const compareArrays = (array1: any[], array2: any[]) => {
  return JSON.stringify(array1) === JSON.stringify(array2);
};

export const getSalutation = (user: {
  profile?: Maybe<{ gender: string }>;
  ecommerce?: Maybe<{ firstName: string }>;
}) => {
  //! gender can be undefined, causing emails not being sent if we try calling toLowerCase() on it
  const gender = user.profile?.gender ? user.profile.gender.toLowerCase() : undefined;

  if (gender === 'männlich') {
    return 'Herr';
  } else if (gender === 'weiblich') {
    return 'Frau';
  } else if (gender === 'divers') {
    return user.ecommerce?.firstName ?? 'Herr/Frau/*';
  } else {
    return 'Herr/Frau/*';
  }
};
